/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable no-restricted-globals                        */
/* ***************************************************************** */
import { useState, React } from 'react';
import {
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { NRX_GROUP_BREAKS } from './constants';

const NrxGroupAdjustment = ({
  aaManagedId,
  currentValues,
  onChange,
  onRevert,
  onSave,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);

  const getAdjustedNrx = (val, defaultValue) => {
    if (isNaN(val)) return defaultValue;
    if (val < 0) return 0;
    if (val > 350) return 350;

    return val;
  };

  const handleChange = (groups, group) => (e) => {
    const itemIndex = groups.findIndex((g) => g.maxValue === group.maxValue);
    if (itemIndex >= 0) {
      onChange([
        ...groups.slice(0, itemIndex),
        {
          aaManagedId,
          minValue: group.minValue,
          maxValue: group.maxValue,
          adjustmentFactor: e.target.value,
        },
        ...groups.slice(itemIndex + 1),
      ]);
    }
  };

  const saveAdjustments = () => {
    setLoading(true);
    onSave();
  };

  const currentValueMap = currentValues.reduce(
    (acc, cur) => ({
      ...acc,
      [cur.maxValue]: cur.adjustmentFactor,
    }),
    {},
  );

  const groups = NRX_GROUP_BREAKS.map((groupBreak, idx, arr) => ({
    aaManagedId,
    minValue: idx === 0 ? 0 : arr[idx - 1] + 1,
    maxValue: groupBreak,
    adjustmentFactor: currentValueMap[groupBreak] || '0',
  }));

  const itemsPerColumn = Math.ceil(groups.length / 3);
  const column1 = groups.slice(0, itemsPerColumn);
  const column2 = groups.slice(itemsPerColumn, itemsPerColumn * 2);
  const column3 = groups.slice(itemsPerColumn * 2);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '.5em' }}>
      {column1.length > 0 ? (
        <Paper style={{ width: '214px', marginRight: '.5em' }}>
          <List>
            {column1.map((group) => (
              <ListItem key={group.maxValue}>
                <ListItemText
                  id={`nrx-group-${group.maxValue}`}
                  primary={`Input ${group.maxValue}`}
                />
                <ListItemSecondaryAction
                  style={{
                    width: '54px',
                    right: '100px',
                    paddingBottom: '5px',
                  }}
                >
                  <TextField
                    variant="standard"
                    id={`nrx-group-adjustment-${group.maxValue}`}
                    key={group.maxValue}
                    value={group.adjustmentFactor}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                    onChange={handleChange(groups, group)}
                    onFocus={(e) => {
                      e.target.select();
                    }}
                  />
                </ListItemSecondaryAction>
                <ListItemText
                  style={{
                    marginLeft: '55px',
                  }}
                  primary={`Adjusted ${getAdjustedNrx(
                    group.maxValue + parseInt(group.adjustmentFactor, 10),
                    group.maxValue,
                  )}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      ) : null}

      {column2.length > 0 ? (
        <Paper style={{ width: '214px', marginRight: '.5em' }}>
          <List>
            {column2.map((group) => (
              <ListItem key={group.maxValue}>
                <ListItemText
                  id={`nrx-group-${group.maxValue}`}
                  primary={`Input ${group.maxValue}`}
                />
                <ListItemSecondaryAction
                  style={{
                    width: '54px',
                    right: '100px',
                    paddingBottom: '5px',
                  }}
                >
                  <TextField
                    variant="standard"
                    id={`nrx-group-adjustment-${group.maxValue}`}
                    key={group.maxValue}
                    value={group.adjustmentFactor}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                    onChange={handleChange(groups, group)}
                    onFocus={(e) => {
                      e.target.select();
                    }}
                  />
                </ListItemSecondaryAction>
                <ListItemText
                  style={{
                    marginLeft: '55px',
                  }}
                  primary={`Adjusted ${getAdjustedNrx(
                    group.maxValue + parseInt(group.adjustmentFactor, 10),
                    group.maxValue,
                  )}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      ) : null}

      {column3.length > 0 ? (
        <Paper style={{ width: '214px' }}>
          <List>
            {column3.map((group) => (
              <ListItem key={group.maxValue}>
                <ListItemText
                  id={`nrx-group-${group.maxValue}`}
                  primary={`Input ${group.maxValue}`}
                />
                <ListItemSecondaryAction
                  style={{
                    width: '54px',
                    right: '100px',
                    paddingBottom: '5px',
                  }}
                >
                  <TextField
                    variant="standard"
                    id={`nrx-group-adjustment-${group.maxValue}`}
                    key={group.maxValue}
                    value={group.adjustmentFactor}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                    onChange={handleChange(groups, group)}
                    onFocus={(e) => {
                      e.target.select();
                    }}
                  />
                </ListItemSecondaryAction>
                <ListItemText
                  style={{
                    marginLeft: '55px',
                  }}
                  primary={`Adjusted ${getAdjustedNrx(
                    group.maxValue + parseInt(group.adjustmentFactor, 10),
                    group.maxValue,
                  )}`}
                />
              </ListItem>
            ))}
          </List>
        </Paper>
      ) : null}

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          width: '130px',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
        }}
      >
        <List>
          <ListItem>
            <Button color="inherit" onClick={onRevert} variant="contained">
              Revert
            </Button>
          </ListItem>
          <ListItem>
            <LoadingButton
              color="inherit"
              loading={loading}
              onClick={saveAdjustments}
              variant="contained"
            >
              Save
            </LoadingButton>
          </ListItem>
          <ListItem>
            <Button color="inherit" onClick={onClose} variant="contained">
              Close
            </Button>
          </ListItem>
        </List>
      </Box>
    </div>
  );
};

export default NrxGroupAdjustment;
